exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-nowrap[data-v-d587a556]:not(.d-block) {\n    margin-right: 10px;\n    display: inline-block;\n}\n", ""]);

// exports
